<template>
  <div>
    <div>
      <div>
        <UpdateProfileInformationForm :user="customer"/>

        <JetSectionBorder/>
      </div>
    </div>
  </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetSectionBorder from '@/Jetstream/SectionBorder.vue';
import UpdateProfileInformationForm from '@/Components/Customer/Partials/UpdateProfileInformationForm.vue';

export default {
  name: "CustomerMasterDataManager",
  components: {
    Link,
    JetSecondaryButton,
    JetSectionBorder,
    UpdateProfileInformationForm,
  },
  props: {
    customer: Object,
  },
  computed: {},
  data() {
    return {
      form: this.$inertia.form({
        salutation_id: this.customer.salutation_id ? this.customer.salutation_id : null,
        internal_uid: this.customer.internal_uid ? this.customer.internal_uid : null,
        name: this.customer.name ? this.customer.name : null,
        departement: this.customer.departement ? this.customer.departement : null,
        email: this.customer.email ? this.customer.email : null,
        company: this.customer.company ? this.customer.company : null,
      }),
    };
  },
  methods: {
  },
}
</script>

<style scoped>

</style>
